import * as qiniu from 'qiniu-js'
import {getToken} from '@/utils/auth.js'
import md5 from 'js-md5';
import {post} from "@/config/config.js"
import {urlpostfix,jsonpostfix} from '@/config/global.js'


var imgBaseUrl = "http://qf965hwmk.hn-bkt.clouddn.com/";

export function uploadFile(file) {

  return new Promise((resolve, reject) => {
    if (file.name) {
      if (isImgType) {
        var putExtra = {
          name: file.name,
          params: {},
          mimeType: ["image/png", "image/jpeg", "image/gif"]
        };

        var config = {
          useCdnDomain: true
        };

        getUploadToken().then((req) => {
          var observable = qiniu.upload(file,
            getKey(),
            req.data,
            putExtra,
            config);
          observable.subscribe(
            (req) => {
            },
            (err) => {
              reject(err)
            },
            (complete) => {
              resolve(complete["key"])
            }) // 上传开始
        }, (err) => {
          reject(err)
        })
      } else {
        reject("非支持图片类型！请更换图片后重新长传")
      }
    } else {
      reject("请选择上传文件！")
    }

  });
}


export function deleteImg(key) {
  let data = {
    key
  }
  return post(`${urlpostfix}api/theme/website/drying/deleteImg`, data);
}

export function deleteImgs(keys) {
  let data = {
    keys
  }
  return post(`${urlpostfix}api/theme/website/drying/deleteImgs`, data);
}

function getKey() {
  let userToken = getToken();
  let timeStamp = new Date().getTime();
  return md5(userToken + timeStamp);
}

function getUploadToken() {
  return post(`${urlpostfix}api/theme/website/drying/getUploadToken`);

}

function isImgType(file) {
  let mimeType = ["image/png", "image/jpeg", "image/gif"]
  let fileType = file.type;
  for (let type in mimeType)
    if (fileType == type)
      return true;
  return false;
}



// WEBPACK FOOTER //
// ./src/utils/upload.js